(function() {
    'use strict';

    angular
        .module('TR')
        .service('hotelsSitemap', hotelsSitemap);

 function hotelsSitemap(
         $location,
         searchUnitService,
         fieldGroupService,
         destinationService,
         $http
    ) {
    const service = {
        getHotels,
        getSize
    };

    const domain = TRPCONFIG.Domain;

    const req = {
        CultureCode: domain.CultureCode,
        DomainId: domain.DomainId,
        CurrencyCode: searchUnitService.getCurrency(),
        Paging: {
            Index: 0,
            Size: 100
        },
        IncludeAggregates: true
    };

    const fieldType = fieldGroupService.getFieldTypes();
    const staticSearchFlags = [
        fieldType.Global,
        fieldType.Titles,
        fieldType.IndicativePrice,
        fieldType.ReviewSnippets,
        fieldType.Url,
        fieldType.Summary,
        fieldType.Recommendations,
        fieldType.EstabGroupIds,
        fieldType.HotelAwards
    ];

    function getHotels(path, pageNum) {
        const _url = '/api/hotels/static/gethotelsbydestination';
        return destinationService.fromUrl(path)
            .then(data => {
                req.Paging.Index = pageNum !== undefined ? pageNum : 0;
                req.DestinationId = data.LegacyId;
                req.DestinationType = data.LegacyType;
                req.PageStrand = data.PageStrand;
                req.FieldFlags = fieldGroupService.getFieldGroup(staticSearchFlags);
                return req;
            })
            .then(req => {
                return $http.post(
                    _url,
                    req)
            .then(res => {
                return res.data;
            });
        });
    }

    function getSize() {
        return req.Paging.Size;
    }

    return service;
}
})();
